import request from '@/utils/request'

// 查询订单申述列表
export function listOrderAppeal(query) {
  return request({
    url: '/order-appeal/order-appeal/list',
    method: 'get',
    params: query
  })
}

// 查询订单申述分页
export function pageOrderAppeal(query) {
  return request({
    url: '/order-appeal/order-appeal/page',
    method: 'get',
    params: query
  })
}

// 查询订单申述详细
export function getOrderAppeal(data) {
  return request({
    url: '/order-appeal/order-appeal/detail',
    method: 'get',
    params: data
  })
}

// 新增订单申述
export function addOrderAppeal(data) {
  return request({
    url: '/order-appeal/order-appeal/add',
    method: 'post',
    data: data
  })
}

// 修改订单申述
export function updateOrderAppeal(data) {
  return request({
    url: '/order-appeal/order-appeal/edit',
    method: 'post',
    data: data
  })
}

// 删除订单申述
export function delOrderAppeal(data) {
  return request({
    url: '/order-appeal/order-appeal/delete',
    method: 'post',
    data: data
  })
}

// 审核通过（状态改为待处理）
export function approveOrderAppeal(data) {
  return request({
    url: '/order-appeal/order-appeal/approve',
    method: 'post',
    data: data
  })
}

// 审核不通过
export function rejectOrderAppeal(data) {
  return request({
    url: '/order-appeal/order-appeal/reject',
    method: 'post',
    data: data
  })
}

// 申述处置
export function handleOrderAppeal(data) {
  return request({
    url: '/order-appeal/order-appeal/handle',
    method: 'post',
    data: data
  })
}
